import { CommitmentKpi } from '../../coaching-base/general';
import { SortDirection } from '../../coaching-insight/oa/models/sorting.model';

export function sortGoals(
    x: CommitmentKpi,
    y: CommitmentKpi,
    direction: SortDirection,
): number {
    if (direction === SortDirection.DEFAULT) {
        return null;
    }
    const result =
        direction === SortDirection.ASC
            ? (+x.updatedOn || +x.createdOn) - (+y.updatedOn || +y.createdOn)
            : (+y.updatedOn || +y.createdOn) - (+x.updatedOn || +x.createdOn);
    return result === 0 ? null : result;
}
